// [hiperautomacao] Labels for what this fork adds on top of Atomic CRM:
// the declared origin, the canonical funnel state, skipped stages, the
// loss reason, the channels of the real conversation history and the
// lead temperature (hot / warm / cold) calculated by the database.
export const hiperMessages = {
  resources: {
    contacts: {
      // The origin has its own question; this field is for everything else.
      field_categories: {
        background_info: "Observações",
      },
      fields: {
        background: "Observações (o que procura, preferências, etc.)",
      },
      hot: {
        title: "Leads quentes",
        empty_hint:
          "Leads quentes aparecem aqui. A temperatura sobe sozinha com os sinais de compra.",
        empty_change_status:
          'Abra um contato e use "Registrar sinal de compra" quando a pessoa der um sinal.',
      },
    },
  },
  hiper: {
    origin: {
      title: "Origem",
      declared: "Como chegou até a gente?",
      declared_help:
        'Escreva como a pessoa disse, sem resumir (ex.: "vi no Instagram da loja").',
      channel: "Canal de origem",
      referred_by: "Quem indicou",
      none: "Origem não registrada",
    },
    funnel: {
      state: "Estado no funil",
      skipped: "Etapas puladas",
      skipped_hint:
        "%{smart_count} etapa pulada |||| %{smart_count} etapas puladas",
      states: {
        novo: "Novo",
        qualificando: "Qualificando",
        qualificado: "Qualificado",
        descartado_agora: "Fora do corte (por agora)",
        oportunidade: "Oportunidade",
        aguardando_aprovacao: "Aguardando aprovação",
        com_humano: "Com atendimento humano",
        resolvido_ganho: "Ganho",
        resolvido_perdido: "Perdido",
        cliente_ativo: "Cliente ativo",
        em_risco: "Em risco",
        dormente: "Dormente",
      },
    },
    loss: {
      reason: "Motivo da perda",
      prompt: "Por que este negócio foi perdido?",
      required: "Para marcar como perdido, escreva o motivo.",
      description:
        "O motivo ensina o que melhorar. Escolha o mais próximo e, se quiser, conte o detalhe.",
      choose_required: "Escolha um motivo.",
      other_needs_detail: 'Em "Outro", escreva o motivo.',
      detail_optional: "Detalhe (opcional)",
      detail_required: "Motivo (obrigatório)",
      confirm: "Marcar como perdido",
      cancelled: "O negócio continua onde estava.",
    },
    notes: {
      conversation: "Conversa registrada",
      read_only:
        "Esta linha é a conversa real com a pessoa: não se altera pelo CRM.",
      channels: {
        whatsapp: "WhatsApp",
        email: "E-mail",
        telefone: "Telefone",
        chat_site: "Chat do site",
        presencial: "Presencial",
        instagram: "Instagram",
        reuniao: "Reunião",
        formulario: "Formulário",
        outro: "Nota",
      },
      directions: {
        entrada: "recebida",
        saida: "enviada",
        interna: "interna",
      },
    },
    temperature: {
      title: "Temperatura",
      values: {
        quente: "Quente",
        morno: "Morno",
        frio: "Frio",
        cliente: "Cliente",
      },
      none: "Sem temperatura ainda",
      since: "desde %{date}",
      corrected: "Corrigida pelo vendedor até %{date}",
      calculated_hint:
        "Calculada pelos sinais de compra, pelas respostas e pelo tempo sem contato.",
      history: "Últimas mudanças",
      history_empty: "Nenhuma mudança registrada.",
      causes: {
        entrada: "chegou",
        sinal: "sinal de compra",
        resposta: "respondeu",
        tempo: "tempo sem contato",
        tentativas: "sem resposta",
        funil: "funil",
        encaixe: "perfil",
        correcao: "correção",
        fim_correcao: "fim da correção",
      },
      signal: {
        action: "Registrar sinal de compra",
        title: "Registrar sinal de compra",
        description:
          "O que a pessoa fez? Sinal forte deixa quente; médio sobe um degrau; fraco só mostra que ela segue ativa.",
        type: "Sinal",
        type_placeholder: "Escolha o sinal",
        note: "Observação (opcional)",
        strength: {
          forte: "forte",
          medio: "médio",
          fraco: "fraco",
        },
        saved: "Sinal registrado. A temperatura foi recalculada.",
        empty_types: "Esta empresa ainda não tem sinais de compra cadastrados.",
        note_question: "Isso é um sinal de compra?",
        note_none: "Não, é só uma nota",
        note_helper:
          "Se a pessoa fez algo que mostra interesse, escolha o sinal: a temperatura é recalculada.",
        saved_with_note:
          "Nota adicionada e sinal registrado. A temperatura foi recalculada.",
      },
      correction: {
        action: "Corrigir temperatura",
        title: "Corrigir temperatura",
        description:
          "Use quando você sabe algo que o sistema não sabe. A correção vale por um prazo (14 dias, se a empresa não mudou) e um novo sinal forte do cliente encerra antes.",
        value: "Temperatura correta",
        reason: "Motivo (obrigatório)",
        reason_placeholder: 'Ex.: "ligou e disse que só decide em março"',
        reason_required: "Escreva o motivo (pelo menos 3 letras).",
        saved: "Temperatura corrigida.",
        remove: "Tirar a correção",
        removed: "Correção retirada. Vale de novo a temperatura calculada.",
      },
      summary: {
        title: "Temperatura dos leads",
        leads: "%{smart_count} lead |||| %{smart_count} leads",
        target: "meta %{value}%",
        target_legend:
          "Meta = referência da Accelera para a divisão dos leads.",
        corrected:
          "%{smart_count} corrigida pelo vendedor |||| %{smart_count} corrigidas pelo vendedor",
        clients: "Clientes: %{smart_count}",
        empty: "Ainda não há leads com temperatura.",
      },
    },
    access: {
      not_seller:
        "Este login ainda não é de um vendedor ativo. Peça a quem administra o CRM para cadastrar o seu e-mail.",
    },
  },
};
